import { DateTime, DateTimeFormatOptions } from "luxon";

export function formatToLocaleString(date: string | undefined, locale: string, formatOption: DateTimeFormatOptions): string {
    if (date === undefined || date === '') {
        return '';
    }
    const dateTime = createDateTime(date);

    return dateTime.setLocale(locale).toLocaleString(formatOption);
}

function createDateTime(date: string): DateTime {
    return DateTime.fromISO(date.replace('Z', ''), { zone: 'Europe/Berlin' });
}
